// extracted by mini-css-extract-plugin
module.exports = {"paymentsTable":"style-module__paymentsTable___fFx9V"};